module.exports = __webpack_public_path__ + "static/media/F5.032c9a77.jpg";